import Header from '@editorjs/header';
import List from '@editorjs/list';
import Paragraph from '@editorjs/paragraph';
import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import Checklist from '@editorjs/checklist';
import BreakLine from 'editorjs-break-line';
import ImageTool from '@editorjs/image';
import { uploadToS3Url } from '@/web/services/upload';
import mediaApi from '@/core/api/modules/media-libraries';
import AlignmentTuneTool from 'editorjs-text-alignment-blocktune';

/**
 * Upload file to the server and return an uploaded image data
 * @param {File} file - file selected from the device or pasted by drag-n-drop
 * @return {Promise.<{success, file: {url}}>}
 */

async function uploadByFile(file) {
  const { type, name, size } = file;
  console.log('type=', type);
  console.log('name=', name);
  console.log('size=', size);
  const fileTypeInfo = type.split('/');

  try {
    const filename = `${new Date().getTime()}-${name}`;
    const { url, public_url } = await mediaApi.getS3UploadUrl(filename, type);
    await uploadToS3Url(url, file, () => true);
    return {
      success: 1,
      file: {
        url: public_url,
      },
    };
  } catch (error) {
    return {
      success: 0,
    };
  }
}

async function uploadByUrl(url) {
  return {
    success: 1,
    file: {
      url,
    },
  };
}

export default {
  tools: {
    paragraph: {
      class: Paragraph,
      tunes: ['alignmentTuneTool'],
    },
    header: {
      class: Header,
      config: {
        placeholder: 'Enter a header',
        levels: [2, 3, 4],
        defaultLevel: 3,
      },
      inlineToolbar: true,
      tunes: ['alignmentTuneTool'],
    },
    list: {
      class: List,
      inlineToolbar: true,
    },
    embed: {
      class: Embed,
      config: {
        services: {
          youtube: true,
          coub: true,
          imgur: true,
        },
      },
    },
    table: {
      class: Table,
      inlineToolbar: true,
      config: {
        rows: 2,
        cols: 3,
      },
    },
    checklist: {
      class: Checklist,
    },
    // Marker: {
    //   class: Marker,
    //   shortcut: 'CMD+SHIFT+M',
    // },
    //image: SimpleImage,
    image: {
      class: ImageTool,
      config: {
        uploader: {
          uploadByFile,
          uploadByUrl,
        },
        captionPlaceholder: 'Optional link URL',
      },
    },
    // breakLine: {
    //   class: BreakLine,
    //   inlineToolbar: true,
    //   shortcut: 'ALT+ENTER',
    // },
    alignmentTuneTool: {
      class: AlignmentTuneTool,
    },
  },
  defaultBlock: 'paragraph',
};
